<template>
  <div class="loading" v-show="visible">
    <div class="loading-box">
      <div class="loading-img"></div>
      <div class="loading-bar"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue';
export default {
  name: 'Loading',
  setup() {
    let visible = ref(false);
    const show = () => {
      visible.value = true;
    };
    const hide = () => {
      visible.value = false;
    };

    return {
      visible,
      show,
      hide,
    };
  },
};
</script>

<style scoped lang="scss">
.loading {
  position: fixed;
  left: 50%;
  top: 50%;
  background-color: rgba(255, 255, 255, 0.7);
  color: white;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  padding: 8px 10px;
  width: 100vw;
  height: 100vh;
  line-height: 100vh;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.loading-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  row-gap: 32px;
}

.loading-img {
  width: 260px;
  height: 38px;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url('https://dts.bmw.com.cn/__statics/eraImages/change/bascic-01.png');
}

.loading-bar {
  width: 265px;
  height: 4px;
  overflow: hidden;

  display: inline-block;
  vertical-align: middle;
  position: relative;
  background: rgb(243, 243, 243, 1);
  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 50%;
    background: linear-gradient(
      90deg,
      #ffe603 0%,
      #ff7401 15%,
      #fe0100 32.5%,
      #ff00ba 46.5%,
      #9512d5 65%,
      #6001b5 78.5%,
      #4021eb 92.5%
    );

    animation-name: loading;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(200%);
    }
  }
}
</style>
